import { render, staticRenderFns } from "./CadastreHistoricalList.vue?vue&type=template&id=449a31ec&scoped=true&"
import script from "./CadastreHistoricalList.vue?vue&type=script&lang=js&"
export * from "./CadastreHistoricalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a31ec",
  null
  
)

export default component.exports